import { render, staticRenderFns } from "./plt.vue?vue&type=template&id=5f476f67&scoped=true"
import script from "./plt.vue?vue&type=script&lang=js"
export * from "./plt.vue?vue&type=script&lang=js"
import style0 from "./plt.vue?vue&type=style&index=0&id=5f476f67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f476f67",
  null
  
)

export default component.exports